import { Pipe, PipeTransform } from '@angular/core';
import { Prescripteur } from '../../models/prescripteur';

@Pipe({
	name: 'filterPrescripteurByName'
})
export class FilterPrescripteurByNamePipe implements PipeTransform {
	transform(prescripteur: Prescripteur[], filter: string): Prescripteur[] {
		if (
			!prescripteur ||
			!filter ||
			prescripteur === null ||
			filter === null ||
			filter === ''
		) {
			return prescripteur;
		}

		return prescripteur.filter((prescripteur: Prescripteur) => {
			if (prescripteur.nomStructure && prescripteur.typeStructure) {
				// TODO: add lastName too
				return prescripteur.nomStructure.toLowerCase().includes(filter.toLowerCase()) ||
				prescripteur.typeStructure.name.toLowerCase().includes(filter.toLowerCase()) ||
				prescripteur.contacts.find(contact => contact.firstName.toLowerCase().includes(filter.toLowerCase()) || 
					contact.lastName.toLowerCase().includes(filter.toLowerCase()));
			}
			return false;
		});
	}
}
